import { render, staticRenderFns } from "./interactive-services-detail.vue?vue&type=template&id=4a9b8a6a&"
import script from "./interactive-services-detail.vue?vue&type=script&lang=js&"
export * from "./interactive-services-detail.vue?vue&type=script&lang=js&"
import style0 from "./interactive-services-detail.vue?vue&type=style&index=0&id=4a9b8a6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports